import { baseService } from './baseService'
import Response from '../data/entity/response_entity'

import { STATUS_CODE } from '../data/system_settings'
import { showErrorToast, toastKey } from '../utils/showToast'

class BookCollectionService extends baseService {
  baseURL = 'book-collection'
  async getAll() {
    try {
      const res = await this.get(this.baseURL)
      if (res.status === STATUS_CODE.SUCCESS) {
        return Response({
          success: true,
          message: {
            content: res.data.data,
          },
        })
      } else {
        return Response({
          success: false,
          message: {
            content: 'Vui lòng liên hệ admin',
          },
        })
      }
    } catch (error) {
      handleError(error)
    }
  }
  async getByUuid(uuid) {
    if (!uuid) {
      return Response({
        success: false,
        message: {
          content: 'Vui lòng chọn gói sách cụ thể',
        },
      })
    }
    try {
      const res = await this.get(`${this.baseURL}/${uuid}`)
      if (res.status === STATUS_CODE.SUCCESS) {
        return Response({
          success: true,
          message: {
            content: res.data.data,
          },
        })
      } else {
        return Response({
          success: false,
          message: {
            content: 'Vui lòng liên hệ admin',
          },
        })
      }
    } catch (error) {
      handleError(error)
    }
  }

  async create({ name }) {
    if (!name) {
      showErrorToast({
        message: 'Vui lòng nhập đủ thông tin',
        toastId: toastKey.BOOKS_MANAGEMENT.PACKAGE.LIST.GET,
      })
      return
    }
    try {
      const res = await this.post(this.baseURL, {
        name: name,
        description: name,
      })
      // Trong tạo gói sách thành công trả về 200 nên toast trả về thông báo lỗi
      if (res.status === STATUS_CODE.SUCCESS) {
        return Response({
          success: true,
          message: {
            content: res.data.data,
          },
        })
      } else {
        return Response({
          success: false,
          message: {
            content: 'Lỗi không xác định',
          },
        })
      }
    } catch (error) {
      return handleError(error)
    }
  }
  async update({ name, uuid }) {
    if (!uuid || !name) {
      showErrorToast({
        message: 'Vui lòng nhập đủ thông tin',
        toastId: toastKey.BOOKS_MANAGEMENT.PACKAGE.LIST.GET,
      })
      return
    }
    try {
      const res = await this.put(`${this.baseURL}/${uuid}`, { name })
      if (res.status === STATUS_CODE.SUCCESS) {
        return Response({
          success: true,
          message: {
            content: res.data.data,
          },
        })
      } else {
        return Response({
          success: false,
          message: {
            content: 'Lỗi không xác định',
          },
        })
      }
    } catch (error) {
      return handleError(error)
    }
  }
  async deleteByUuid({ uuid }) {
    if (!uuid) {
      showErrorToast({
        message: 'Vui lòng nhập đủ thông tin',
        toastId: toastKey.BOOKS_MANAGEMENT.PACKAGE.LIST.GET,
      })
      return
    }

    try {
      const response = await this.delete(`${this.baseURL}/${uuid}`)

      return response
    } catch (error) {
      return handleError(error)
    }
  }

  async addGroups({ collection, groups }) {
    if (!collection) {
      showErrorToast({
        message: 'Vui lòng chọn gói sách',
        toastId: toastKey.BOOKS_MANAGEMENT.PACKAGE.LIST.GET,
      })
      return
    }

    try {
      const res = await this.post(`${this.baseURL}/set`, { collection, groups })

      if (res.status === STATUS_CODE.SUCCESS) {
        const response = Response({
          success: true,
          message: {
            content: res.data.data,
          },
        })
        return response
      } else {
        const response = Response({
          success: false,
          message: {
            content: 'Lỗi không xác định',
          },
        })
        return response
      }
    } catch (error) {
      return handleError(error)
    }
  }
  async getInfoUserOfBookPackage(uuid) {
    try {
      const res = await this.get(`book-collection/info/${uuid}`)
      if (res?.status === 200 && res?.data?.data) {
        return res?.data?.data
      } else {
        throw new Error('Lỗi khi lấy dữ liệu nhóm người dùng của gói sách')
      }
    } catch (error) {
      throw new Error(
        error.message || 'Lỗi khi lấy dữ liệu nhóm người dùng của gói sách'
      )
    }
  }
}
const handleError = (error) => {
  let message = error.response.data.meta.message || 'Lỗi không xác định'

  return Response({ success: false, message: { content: message } })
}

export const bookCollectionService = new BookCollectionService()
